// Filename: models/questionnaire/question.js
define('models/questionnaire/comment',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MComment = Backbone.Model.extend({
        idAttribute: 'questionId',

    });

    // Return the model for the module
    return MComment;
});

